import { FC, ReactElement } from 'react'

import { ConnectedEmployeeBalancesPerPeriod } from '@/connectors'

export const LoketHoursPerPeriodPage: FC = (): ReactElement => <ConnectedEmployeeBalancesPerPeriod />
